import { stringify } from 'query-string';
import { MAX_LIMIT } from 'config';

import { ChartTypes, sortOrderTypes } from 'types/shared';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { IFrequencyType } from 'components/data-containers/PositionsTable/shared/shared';

import getCountryIds from 'helpers/getCountryIds';

export interface IChartsListURLArgs {
  chartIds?: string | string[];
  countryIds?: string | string[];
  customerFilter?: TopicFilterNames[];
  productType?: string;
  chartType?: ChartTypes;
  sortOrder?: sortOrderTypes;
  chartFrequency?: IFrequencyType;
  sortBy?: string;
  limit?: number;
  offset?: number;
  customRegion?: string | string[];
  region?: string;
}

export default function getChartsListURL(args: IChartsListURLArgs): string {
  const {
    chartIds,
    chartType,
    customerFilter,
    countryIds,
    productType,
    sortBy,
    sortOrder,
    limit = MAX_LIMIT,
    offset,
    chartFrequency,
    customRegion,
    region,
  } = args;

  const params = stringify({
    customerFilter,
    countryIds: getCountryIds(countryIds, region, customRegion),
    chartIds,
    chartType,
    productType,
    sortBy,
    sortOrder,
    limit,
    offset,
    chartFrequency,
  });

  return `/api/charts/list?${params}`;
}
